export default __webpack_public_path__ + "static/media/settings_73391.33c19683.svg";